$(document).ready(function(){
  
  function cookies(){
    
    var cookiebar = $('div#bp-cookie-bar');

      if (cookiebar.hasClass('show-cookie-bar')) {
      } else {
        setTimeout(function(){
        $('div#loyaltylion-notification-container').addClass('bottom0');
        },500); 
      }
  };
  
  cookies();
  
  $('#bp-accept-cookie').click(function(){
    cookies();
  });
  
  $('li.product__size:not(.msg)').click(function(){
    $('#msg_barrel').slideUp();
    $('ul.product__slides').show();
    $('ul.product__slides_barrel').hide();
    $('ul.product__available-sizes').removeClass('barrel');
	$('button.product__add-to-cart').show();
	$('a#barrel_reg').hide();
    $('span.product__price.h4').show();


  });
  
  
  $('li.product__size.msg').click(function(){
    $('#msg_barrel').slideDown();
    $('ul.product__slides').hide();
    $('ul.product__slides_barrel').show();
    $('ul.product__available-sizes').addClass('barrel');
    $('button.product__add-to-cart').hide();
	$('a#barrel_reg').show();
    $('span.product__price.h4').hide();

  });

  
if ( window.location.hash ) scroll(0,0);
setTimeout( function() { scroll(0,0); }, 50);

$(function() {

    $('.scroll').on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $($(this).attr('href')).offset().top + 'px'
        }, 500, 'swing');
    });

    if(window.location.hash) {

        $('html, body').animate({
            scrollTop: $(window.location.hash).offset().top -100 + 'px'
        }, 200, 'swing');
    }

});
  
  var dots = function(){
    $('.section-featured-collection ul.slider-dots li:first-child button').trigger('click');
  }
  
  dots();
  
     $(window).resize(function() {
       if ($(window).width() <= 562) {
  			dots();
       }
     })
    
    
});
        
 


